export function KeepAwake() {
  return <></>;
}
